export default "__VITE_ASSET__D$Um0pbt__"